"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryFlag = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {object} props
 * @param {string} props.code Country code to correspond the flag
 * @param {string} props.width Width of flag image
 * @param {string} props.height Height of flag image
 * @param {string} props.name Name to use as flag image alt
 * Also see https://flagcdn.com/ for more available size options, if needed
 * Flag Image is the most reliable way to render a flag, since emoji do not work on mutiple platforms
 * We might further customize this component, if there's a need in future
 */

var DEFAULT_COUNTRY_FLAG_HEIGHT = 12;
var DEFAULT_COUNTRY_FLAG_WIDTH = 16;
var getFlagCdnSrc = function getFlagCdnSrc(width, height, code) {
  return "https://flagcdn.com/".concat(width, "x").concat(height, "/").concat(code, ".png");
};
var CountryFlag = function CountryFlag(_ref) {
  var code = _ref.code,
    name = _ref.name,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? DEFAULT_COUNTRY_FLAG_WIDTH : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? DEFAULT_COUNTRY_FLAG_HEIGHT : _ref$height,
    className = _ref.className;
  var lowerCode = (0, _lodash.toLower)(code);
  return /*#__PURE__*/_react.default.createElement("img", {
    src: getFlagCdnSrc(width, height, lowerCode),
    srcSet: "".concat(getFlagCdnSrc(width * 2, height * 2, lowerCode), " 2x,") + "".concat(getFlagCdnSrc(width * 3, height * 3, lowerCode), " 3x"),
    width: width,
    height: height,
    className: className,
    alt: name
  });
};
exports.CountryFlag = CountryFlag;